import React from 'react'

const BlankPage = () => (
  <div data-id='BlankPage' />
)

export default BlankPage
